/* eslint-disable @typescript-eslint/naming-convention */
import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  GetDirectPutawayParamsType,
  GetDirectPutawayResponseType,
} from 'features/PurchaseOrder/services/directPutaway'
import { SLICE_NAME, fetchGetLocations, fetchGetDirectPutaway } from './thunk'

export type ConstantType = {
  id: number
  name: string
}

export type DirectPutawayStateType = {
  isLoading: boolean
  query: GetDirectPutawayParamsType
  constants: {
    locations: ConstantType[]
  }
  pagination: {
    page_size: number
    page_index: number
  }
  data: GetDirectPutawayResponseType['data']
}

const initialState: DirectPutawayStateType = {
  isLoading: false,
  query: {
    'pagination.page_index': 1,
  },
  constants: {
    locations: [],
  },
  pagination: {
    page_size: 20,
    page_index: 1,
  },
  data: [],
}

const directPutawaySlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<DirectPutawayStateType>) => {
      builder
        .addCase(fetchGetDirectPutaway.pending, (state, action) => {
          state.query = {
            ...state.query,
            ...action.meta.arg,
          }
        })
        .addCase(fetchGetDirectPutaway.fulfilled, (state, action) => {
          const {
            data,
            pagination: { page_index, page_size },
          } = action.payload

          state.data = data
          state.pagination = {
            page_size,
            page_index,
          }
        })
        .addCase(fetchGetDirectPutaway.rejected, (state) => {
          state.data = []
          state.pagination = {
            page_index: 1,
            page_size: 20,
          }
        })
        // =====
        .addCase(fetchGetLocations.fulfilled, (state, action) => {
          state.constants.locations = action.payload.map((loc) => ({
            id: loc.location_id,
            name: loc.location_name,
          }))
        })
    },
    [fetchGetDirectPutaway],
  ),
})

export const { reset } = directPutawaySlice.actions
export default directPutawaySlice.reducer
